import React from 'react';
import { Badge, Button } from '@dev-go4ellis/go4-design-system';

// "Option 1a" treatment for the Ready to Post CTAs (GO4-<ticket>) — an asymmetric
// layout that leans on the primary "post a job" action instead of presenting both
// choices as equal. Gated behind helpers/readyToPostVariant until the linked
// segmentation ticket lands.
const ReadyToPostTreatmentCards = ({ onReadyToPost, onJustBrowsing, atsWithin50Miles, statsLoaded, zip }) => {
  // Falls back to the page's own "5,000+ organizations" line (already stated in the header
  // above) until the real ATs-within-50-miles count loads, rather than a placeholder dash.
  const proofCopy =
    statsLoaded && typeof atsWithin50Miles === 'number'
      ? `${atsWithin50Miles} verified ${atsWithin50Miles === 1 ? 'AT' : 'ATs'} within 50 miles of ${
          zip || 'your ZIP'
        }`
      : 'Join 5,000+ organizations already covered by Go4';

  return (
    <div className="ready-to-post-treatment">
      <div className="ready-to-post-treatment__primary">
        <div className="ready-to-post-treatment__eyebrow">
          <Badge tone="warning" variant="solid" className="ready-to-post-treatment__badge">
            Recommended
          </Badge>
          <span className="ready-to-post-treatment__time">About 2 minutes</span>
        </div>
        <p className="ready-to-post-treatment__title">Post Your First Job</p>
        <p className="ready-to-post-treatment__body">
          Don&apos;t have every detail yet? Add what you know and save it as a draft. Nothing goes live until
          you say so, and you&apos;re only charged once an AT accepts.
        </p>
        <Button variant="primary" className="ready-to-post-treatment__cta" onClick={onReadyToPost}>
          Post my first job →
        </Button>
        <div className="ready-to-post-treatment__divider" />
        <p className="ready-to-post-treatment__proof">{proofCopy}</p>
      </div>
      <div className="ready-to-post-treatment__secondary">
        <p className="ready-to-post-treatment__secondary-title">I&apos;m Just Browsing</p>
        <p className="ready-to-post-treatment__secondary-body">
          Take me to my dashboard. I can start a job from there any time.
        </p>
        <Button variant="ghost" className="ready-to-post-treatment__secondary-cta" onClick={onJustBrowsing}>
          Go to dashboard
        </Button>
      </div>
    </div>
  );
};

export default ReadyToPostTreatmentCards;
